import { render } from "./CrashHistoryElement.vue?vue&type=template&id=673d30d2&scoped=true"
import script from "./CrashHistoryElement.vue?vue&type=script&lang=js"
export * from "./CrashHistoryElement.vue?vue&type=script&lang=js"

import "./CrashHistoryElement.vue?vue&type=style&index=0&id=673d30d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673d30d2"]])

export default __exports__